import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
const pathname = window.location.pathname || '/';

// The build-time SSG shell is intentionally framework-independent. It gives
// crawlers and no-JS clients complete route content, then the browser replaces
// it with the interactive React application once the production bundle loads.
if (container.hasChildNodes()) {
  container.replaceChildren();
}

createRoot(container).render(<App pathname={pathname} />);
